import { Reducer } from 'redux';
import { MatchingUsersActions } from './actions';
import {
  QueryCacheOptions,
  SearchSessionsResponse,
  SearchUser,
} from '@fullstory/proto/fs/services/alexa';
import { SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { EventSearch } from '@fullstory/proto/fs/api/search';

export enum MatchingUsersTypes {
  FetchUsersLoading = 'matchingUsers.fetchLoading',
  FetchUsersStart = 'matchingUsers.fetchUsersStart',
  FetchUsersSuccess = 'matchingUsers.fetchUsersSuccess',
  FetchUsersFailure = 'matchingUsers.fetchUsersFailure',
  FetchUsersCacheUpdate = 'matchingUsers.fetchUsersCacheUpdate',
  FetchUsersCacheSwap = 'matchingUsers.fetchUsersCacheSwap',
  TimeRangeCacheUpdate = 'matchingUsers.timeRangeCacheUpdate',
  TimeRangeCacheSwap = 'matchingUsers.timeRangeCacheSwap',
  AllTimeRangeCacheUpdate = 'matchingUsers.allTimeRangeCacheUpdate',
  AllTimeRangeCacheSwap = 'matchingUsers.allTimeRangeCacheSwap',
  FetchMatchingUsersStart = 'matchingUsers.fetchMatchingUsersStart',
  FetchMatchingUsersSuccess = 'matchingUsers.fetchMatchingUsersSuccess',
  FetchMatchingUsersFailure = 'matchingUsers.fetchMatchingUsersFailure',
  FetchSessionsStart = 'matchingUsers.fetchSessionsStart',
  FetchSessionsSuccess = 'matchingUsers.fetchSessionsSuccess',
  FetchSessionsFailure = 'matchingUsers.fetchSessionsFailure',
  FetchTimeRangeStart = 'matchingUsers.fetchTimeRangeStart',
  FetchTimeRangeSuccess = 'matchingUsers.fetchTimeRangeSuccess',
  FetchTimeRangeFailure = 'matchingUsers.fetchTimeRangeFailure',
  FetchAllTimeRangeStart = 'matchingUsers.fetchAllTimeRangeStart',
  FetchAllTimeRangeSuccess = 'matchingUsers.fetchAllTimeRangeSuccess',
  FetchAllTimeRangeFailure = 'matchingUsers.fetchAllTimeRangeFailure',
  SearchSessionsRequest = 'matchingUsers.searchSessionsRequest',
  SearchSessionsSuccess = 'matchingUsers.searchSessionsSuccess',
  SearchSessionsFailure = 'matchingUsers.searchSessionsFailure',
  SeedData = 'matchingUsers.seedData',
  ResetAutoplay = 'matchingUsers.resetAutoplay',
  SetAutoplayContext = 'matchingUsers.setAutoplayContext',
}

export interface SeedData {
  users: SearchUser[];
  numMatchingUsers: number;
  start: number;
}

export interface AutoplayContext {
  // segment definition for MatchingUsers
  matchingUsersSegmentDefinition: SegmentDefinition | null;
  // additional segment definitions for MatchingUsers
  matchingUsersAdditionalSegmentDefinitions: SegmentDefinition[];
  // segment definitions for SearchSessions
  searchSessionsSegmentDefinitions: SegmentDefinition[];
  // segment definition to use for markers in playback
  markersSegmentDefinition: SegmentDefinition | null;
  // event search for everything (overrides) except markers
  eventSearch: EventSearch | null;
  currPage: number;
  pageSize: number;
  // cache options to use for MatchingUsers
  cacheOptions: ((page: number) => QueryCacheOptions | null) | null;
  // user-readable name, such as the segment name, to be displayed for the current autoplay context
  name: string;
}

export interface ApiRequestState<D> {
  loading: boolean;
  error: boolean;
  data: D;
}

export type ApiRequestReducer<D> = Reducer<ApiRequestState<D>, MatchingUsersActions>;

export type SearchSessionsMap = { [individualId: string]: SearchSessionsResponse };

export enum WelcomeState {
  EMPTY_ORG,
  HAS_SESSIONS,
  HAS_MATCHING,
}

// Deprecated. Only used in matching user searchie.
// Please use AppCacheStatus for app caching
export enum MatchingUserAppCacheStatus {
  // Initial Load
  initial = 'INITIAL',
  // Fetching new data after being in middle state
  isRefetching = 'IS_REFETCHING',
  // Fetching new data on initial load or in refresh state
  isLoading = 'IS_LOADING',
  hasData = 'HAS_DATA',
  // Errored after fetching for data
  loadFailed = 'LOAD_FAILED',
  // Rendering new data
  fresh = 'FRESH',
  // Allow the button to swap into a hidden state (app cache disabled)
  hidden = 'HIDDEN',
  middle = 'MIDDLE',
}
